module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-152x152-precomposed-2569d237994309f0f2b9df642a6b05cc.png";